// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Instagram: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<path d="M16.85,0h-9.7C3.21,0,0,3.21,0,7.15v9.7C0,20.79,3.21,24,7.15,24h9.7c3.94,0,7.15-3.21,7.15-7.15v-9.7
	C24,3.21,20.79,0,16.85,0z M21.75,16.93c0,2.66-2.16,4.82-4.82,4.82H7.07c-2.66,0-4.82-2.16-4.82-4.82V7.07
	c0-2.66,2.16-4.82,4.82-4.82h9.87c2.66,0,4.82,2.16,4.82,4.82V16.93L21.75,16.93z M12,6c-3.31,0-6,2.69-6,6c0,3.31,2.69,6,6,6
	s6-2.69,6-6S15.31,6,12,6z M12,15.75c-2.07,0-3.75-1.68-3.75-3.75S9.93,8.25,12,8.25s3.75,1.68,3.75,3.75S14.07,15.75,12,15.75z
	 M18,7.13c0-0.46,0.27-0.87,0.69-1.04s0.9-0.08,1.23,0.24s0.42,0.81,0.24,1.23s-0.58,0.69-1.04,0.69L18,7.13z"/>
</svg>;
};

export default React.memo(Instagram);
